export default "__VITE_ASSET__53ad57ca__"